import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
const HeroShowcase: React.FC = () => {
  const {
    user
  } = useAuth();
  const ctaLink = user ? '/assessments' : '/auth?returnUrl=/assessments';
  const ctaText = 'Access the Marketing & Sales Self Audit tool';
  return <div className="max-w-2xl w-full">
      <div className="bg-card/95 backdrop-blur-sm rounded-sm p-[clamp(1rem,2.5vw,2rem)] border border-border/30 shadow-lg text-zinc-400">
        <h1 className="text-[clamp(1.25rem,2.2vw,2.25rem)] font-semibold leading-relaxed mb-2 text-muted-foreground">
          Assess Where Your B2B Manufacturing Business Stands. Know Where to Move Next.
        </h1>

        <div className="bg-primary w-full mt-[clamp(0.75rem,2vh,1.5rem)] p-[clamp(0.75rem,2vw,1rem)] rounded-sm" role="region" aria-label="Call to action">
          <Link to={ctaLink} className="text-primary-foreground hover:no-underline hover:bg-primary-foreground/20 focus:bg-primary-foreground/20 focus:outline-none focus:ring-2 focus:ring-primary-foreground focus:ring-offset-2 focus:ring-offset-primary active:scale-95 transition-all duration-200 px-3 py-2 rounded inline-block font-bold text-xl" aria-label={ctaText}>
            {ctaText}
          </Link>
        </div>
      </div>
    </div>;
};
export default HeroShowcase;